// 用户信息
export interface UserInfoIF {
  id: number;
  accountId: string;
  /** 账户名 */
  accountName: string;
  /** 邮箱 */
  email: string;
  /** 角色名 */
  roleName: string;
  roleNameEn: string;
  /** 角色 */
  roleCode: string;
  /** 是否新用户 */
  isNewUser: boolean;
  /** 是否已有项目 */
  hasProject: boolean;
  /** 是否接受邀请 */
  isAcceptedInvitation: boolean;
  /** 是否开启预测标签 */
  predictiveTagSwitch: boolean;
  /** 是否开通 in-game */
  inGame: boolean;
  /** 时区 */
  timeZone: string;
  /** 时间格式 */
  timeFormat: string;
  /** 是否已查看区域管理 */
  isViewRegionGroup: boolean;
}

// 被邀请项目申请信息
export interface ProjectApplyInfoIF {
  invitationCode: string;
  inviter: string;
  projectId: number;
  projectName: string;
  roleName: string;
  roleCode: string;
  /** 是否为sml系统内用户 */
  isExistingUser: boolean;
}

/** 角色信息 */
export enum RoleCodeEnum {
  /** 内部角色 */
  INTERNAL = 'SmartLink_Internal',
  /** owner - 项目所有者，拥有项目的最高权限 */
  OWNER = 'SmartLink_Owner',
  /** admin - 可以创建、编辑、审批campaign */
  ADMIN = 'SmartLink_Admin',
  /** Manager - 允许用户创建电子邮件模板、创建和发送活动、导入联系人。此用户类型无法邀请新用户。 */
  MANAGER = 'SmartLink_Manager',
  /** author - 可以创建、编辑campaign，不能审批campaign */
  AUTHOR = 'SmartLink_Author',
  /** operator - 运营人员，业务不能申请 */
  OPERATOR = 'SmartLink_Operator',
  /** viewer - 体验角色，用户不需要申请 */
  VIEWER = 'SmartLink_Viewer',
  /** Conversion数据查看角色 */
  GAME_DATA_ADMIN = 'SmartLink_GameDataAdmin',
}

/** 角色信息 */
export interface RoleListItemIF {
  gameId: number;
  roleCode: RoleCodeEnum;
  roleNameEn: string;
  roleNameZh: string;
  roleUuid: string;
  // Conversion数据查看角色（1：是，0：否）
  isGameDataAdmin: number;
}

/** 角色判断 */
export type RolesKeyType =
  | 'isInternal'
  | 'isOwnerAdminManage'
  | 'isOwnerAdmin'
  | 'isOwner'
  | 'isAdmin'
  | 'isManage'
  | 'isAuthor'
  | 'isOperator'
  | 'isViewer'
  | 'isGameDataAdmin';

/** 角色判断 */
export type RoleJudgmentType = Record<RolesKeyType, boolean>;

/** 业务信息 */
export interface BusinessListItemIF {
  gameId: number;
  gameName: string;
  gameNameZh: string;
  gameNameEn: string;
  iconUrl: string;
  bgUrl: string;
  roles: string[];
  /** 联系人列表提示 0 - 未授权 1 - 已授权 */
  isAuthorize: number;
  /** 当前sml-console业务ID对应PNT内的业务id（存在业务id值不相同的情况）
   * 0：代表sml和PNT业务ID值一致
   * 非0：代表sml和PNT业务ID值不一致，且此值为PNT的业务ID
   */
  pntGameId: number;
  // 标识业务是否接入ingame数据业务的Conversion模块 1：已接入 0：未接入
  hasGameData: number;
  // 推送授权状态 1：已授权 0：未授权
  isPushAuthorize: number;
  // Whatsapp授权状态 1：已授权 0：未授权
  isWaAuthorize: number;
}

/** 1：注册，2：忘记密码 */
export enum CodeTypeEnum {
  /** 注册 */
  REGISTER = 1,
  /** 忘记密码 */
  FORGOT_PASSWORD = 2,
}

/** 发送验证码 */
export type SendCodeFormType = {
  email: string;
  /** 1：注册，2：忘记密码 */
  codeType: number;
  /** 谷歌验证码 */
  captchaToken?: string;
};

/** 校验验证码 */
export type CheckCodeFormType = {
  email: string;
  /** 1：注册，2：忘记密码 */
  codeType: number;
  code: string;
};

/** 时区 */
export interface TimezoneListItem {
  textEn: string;
  textZh: string;
  value: string;
  time: number;
}

/** 需要的配置 */
export interface NeedConfigIF {
  name: string;
  status: number;
  type: number;
}

/** 获取列表操作项被其它信息引用进而禁用状态及信息 */
export const enum usedStatusTypeEnum {
  ONE = 1, // 被API引用
  TWO = 2, // 被激活状态的表单引用
  THREE = 3, // 被线上活动引用
  FOUR = 4, // 被自动化活动引用
  FIVE = 5, // 被模板引用
}

/** 获取列表操作项被其它信息引用进而禁用状态及信息 - 类型 */
export interface UsedStatusType {
  quotaType: usedStatusTypeEnum;
  campaignState?: number; // 活动状态 & 自动化活动状态
  pauseType?: number;
}

// 当前项目下首个用户加入的时间
export interface GameFirstUserInfoType {
  gameId: number;
  createdAt: string;
  timeZone: string;
  timeYMD: string;
  timeHMS: string;
}
